import { gql, useMutation } from 'urql';

export const UPDATE_TICKETS_MUTATION = gql`
  mutation UpdateTickets($ticketIds: [Int!]!, $ticketSegmentId: Int, $invitationStatus: String) {
    updateTickets(
      ticketIds: $ticketIds
      input: { ticketSegmentId: $ticketSegmentId, invitationStatus: $invitationStatus }
    ) {
      rowsAffected
      segmentTitle
    }
  }
`;

export interface UpdateTicketsVariables {
  ticketIds: number[];
  ticketSegmentId?: number;
  invitationStatus?: string;
}

export interface UpdateTicketsResponse {
  updateTickets: {
    rowsAffected: number;
    segmentTitle: string;
  };
}

export const useUpdateTickets = () => {
  const [result, executeMutation] = useMutation<UpdateTicketsResponse, UpdateTicketsVariables>(UPDATE_TICKETS_MUTATION);
  return { updateTickets: executeMutation, fetching: result.fetching, error: result.error };
};
